// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3NMeK","right":"styles_right__3tcGi"};